// GENERATED by scripts/build-icons.mjs from icons/sliders-horizontal.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const SlidersHorizontal = createIcon('sliders-horizontal', [
  ['path', { d: "M10 5H3" }],
  ['path', { d: "M12 19H3" }],
  ['path', { d: "M14 3v4" }],
  ['path', { d: "M16 17v4" }],
  ['path', { d: "M21 12h-9" }],
  ['path', { d: "M21 19h-5" }],
  ['path', { d: "M21 5h-7" }],
  ['path', { d: "M8 10v4" }],
  ['path', { d: "M8 12H3" }],
])
